import { buildResizableImageUrl, DEFAULT_IMAGE } from '@autone/utils';
import { type HTMLProps, useState } from 'react';

type ImageProps = Omit<HTMLProps<HTMLImageElement>, 'src' | 'size'> & {
  src?: string | undefined | null;
  size?: 'small' | 'medium' | 'large';
};

const Image = (props: ImageProps) => {
  const [error, setError] = useState(false);
  const { src, size, ...rest } = props;

  if (error || !src) {
    return (
      <img
        {...rest}
        alt={props.alt}
        src={buildResizableImageUrl(DEFAULT_IMAGE, size)}
      />
    );
  }

  return (
    <img
      {...rest}
      alt={props.alt}
      onError={() => setError(true)}
      src={buildResizableImageUrl(src, size)}
    />
  );
};

export default Image;
